import type { CrmAccountStatus } from "@shared/modules/crm";
import { Badge } from "../../../core/components/ui/badge";
import { CRM_STATUS_LABELS, CRM_STATUS_VARIANT } from "../lib/crm";

export function CrmStatusBadge({ status }: { status: CrmAccountStatus }) {
  return <Badge variant={CRM_STATUS_VARIANT[status]}>{CRM_STATUS_LABELS[status]}</Badge>;
}
